export default __webpack_public_path__ + "static/media/circle-background.be299adb.svg";